console.log("heiiiiii");
document.addEventListener("DOMContentLoaded", function () {
   console.log("hello");
    const buyNowBtn = document.getElementById("buy-now-btn");
    if (buyNowBtn) {
        buyNowBtn.addEventListener("click", function (event) {
            event.preventDefault(); // Prevents form submission
            const form = document.querySelector("form[action^='/cart/add']");
            const formData = new FormData(form);

            fetch('/cart/clear.js', { method: 'POST' }) // Clear cart before adding product
                .then(() => {
                    return fetch('/cart/add.js', {
                        method: 'POST',
                        body: formData
                    });
                })
                .then(() => {
                    window.location.href = '/checkout'; // Redirects to checkout
                })
                .catch(error => console.error("Buy Now Error:", error));
        });
    }
  
});
document.addEventListener("DOMContentLoaded", function () {
    function updateProgressBar(cartTotal) {
        const threshold = 499;
        const progress = document.querySelector(".progress_bar_done");
        const amountNeeded = document.getElementById("amount-needed");

        if (progress && amountNeeded) {
            let progressValue = (cartTotal * 100) / threshold;
            if (progressValue > 100) progressValue = 100;

            // Update progress bar width
            progress.style.width = progressValue + "%";

            // Update text message
            let remainingAmount = threshold - cartTotal;
            if (remainingAmount > 0) {
                amountNeeded.textContent = remainingAmount;
            } else {
                amountNeeded.textContent = "0";
            }
        }
    }

    // Fetch updated cart total
    function fetchCartTotal() {
        fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                let cartTotal = cart.total_price / 100; // Convert cents to kr
                updateProgressBar(cartTotal);
            })
            .catch(error => console.error("Error fetching cart:", error));
    }

    // Listen for quantity change
    document.addEventListener("change", function (event) {
        if (event.target.matches("input[name='quantity']")) {
            setTimeout(fetchCartTotal, 500); // Delay to allow Shopify to update
        }
    });

    // Initial progress bar update
    fetchCartTotal();
});
